import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { AssessmentGroups } from 'modules/competencies/store/collections/assessmentGroups'
import { Assessments } from 'modules/competencies/store/collections/assessments'
import { EmployeeAssessmentGroups } from 'modules/competencies/store/collections/employeeAssessmentGroups'
import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'

interface Values {
  loading: boolean
  assessments: Assessments
  assessmentGroups: AssessmentGroups
  employeeAssessmentGroups: EmployeeAssessmentGroups
}

const Context = React.createContext<Values | null>(null)

export const AssessmentsProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const assessments = React.useRef(new Assessments()).current
  const assessmentGroups = React.useRef(new AssessmentGroups()).current
  const employeeAssessmentGroups = React.useRef(new EmployeeAssessmentGroups()).current

  const { loading } = useAsyncData(
    () =>
      Promise.all([
        assessments.fetch(),
        assessmentGroups.fetch(),
        employees.fetch(),
        contractVersions.fetch(),
        employeeAssessmentGroups.fetch(),
      ]),
    []
  )

  const values: Values = {
    loading,
    assessments,
    assessmentGroups,
    employeeAssessmentGroups,
  }

  return <Context.Provider value={values}>{children}</Context.Provider>
}

export const useAssessments = (): Values => {
  const values = React.useContext(Context)

  if (!values) throw new Error('useAssessments must be used within a AssessmentsProvider')

  return values
}
